import { QRCodeCanvas as QRCode } from "qrcode.react";
import { Form } from "react-bootstrap";

import classes from "../Inventory/inventory.module.scss";

import { dateToLocale } from "@/services/Utils";

const EmptyContainerTableDetail = ({ selected, container, handleCheckInventory }) => {
	if (!container.active) {
		return null;
	}

	const validCheck = (inventory) => {
		let checked = false;

		const findChecked = selected.find((_s) => selected.includes(inventory.original_id));

		if (findChecked) {
			checked = true;
		}

		return checked;
	};

	return (
		<tr className={classes.table_detail}>
			<td colSpan={6} className={classes.td_table}>
				<table className={classes.table_item}>
					<thead>
						<tr className={classes.table_item_tr}>
							<th className={classes.th_detail} style={{ width: "3%" }}></th>
							<th className={classes.th_detail} style={{ width: "5%" }}>
								Cód.
							</th>
							<th className={classes.th_detail} style={{ width: "5%" }}>
								Nombre comercial
							</th>
							<th className={classes.th_detail} style={{ width: "5%" }}>
								Fecha envase vacío
							</th>
							<th className={classes.th_detail} style={{ width: "5%" }}>
								QR
							</th>
						</tr>
					</thead>
					<tbody>
						{container.details.map((detail, i) => {
							return (
								<tr key={i} className={`${classes.table_item_tr}`}>
									<td className={classes.table_item_td}>
										<div
											className={`${classes.div_item} ${classes.first_div} `}
											style={{
												justifyContent: "start",
												paddingLeft: "15px",
											}}
										>
											<Form.Check type="checkbox" checked={validCheck(detail)} onChange={(e) => handleCheckInventory(detail, e)} />
										</div>
									</td>

									<td className={classes.table_item_td}>
										<div className={`${classes.div_item} ${classes.first_div} `}>{detail.inventory_id}</div>
									</td>
									<td className={classes.table_item_td}>
										<div className={`${classes.div_item} `}>{detail.tradename}</div>
									</td>
									<td className={classes.table_item_td}>
										<div className={`${classes.div_item} `}>{detail.empty_date ? dateToLocale(detail.empty_date) : ""}</div>
									</td>
									<td className={classes.table_item_td}>
										<div className={`${classes.div_item} ${classes.last_div} `}>
											<QRCode
												value={`${detail.original_id}`}
												size={40}
												style={{
													marginTop: "4px",
													cursor: "pointer",
												}}
											/>
										</div>
									</td>
								</tr>
							);
						})}
					</tbody>
				</table>
			</td>
		</tr>
	);
};

export default EmptyContainerTableDetail;
